export function initFetchEmailButton(): void {
  $(document).off('click', '.fetch-email-btn').on('click', '.fetch-email-btn', e => {
    e.stopPropagation();
    const $target = $(e.currentTarget);
    const id = $target.data('prospect-id')
    const botsProspectId = $target.data('bots-prospect-id')
    const $pop = $target.closest('.popover');
    const popId = $pop.attr('id');
    const $trigger = $('[aria-describedby="' + popId + '"]');
    const $spinner = $('<div class="ml-auto"><i class="fas fa-spinner fa-spin"></i> Fetching...</div>');
    const $emailBtn = $('.email-button-' + botsProspectId);
    const $replaceTarget = $target.closest('.no-email-address').length ? $target.closest('.no-email-address') : $target;

    $replaceTarget.replaceWith($spinner);

    $.ajax({
      url: `/bots_prospects/${botsProspectId}/fetch_email_addresses`,
      type: 'POST',
      success: function(data) {
        if(data.status == 'found') {
          const content = "<div class='close-popover'><i class='far fa-times'></i></div>" +
                          "<div class='email-address'>Personal email found</div>"
          $trigger.attr('data-content', content);
          $spinner.replaceWith(content);
        } else if (data.status == 'not_found') {
          const content = "<div class='close-popover'><i class='far fa-times'></i></div>" +
            `<div class="no-email-address d-flex align-items-center">
              No email found
              <button class="btn fetch-email-btn btn-refetch" data-prospect-id="${id}" data-bots-prospect-id="${botsProspectId}">
                <img src="/refresh.svg" alt="refresh" class="refresh-icon">
              </button>
            </div>`;
          $trigger.attr('data-content', content);
          $spinner.replaceWith(content);
        }

        $trigger.removeClass('found not-found').addClass(data.status === 'found' ? 'found' : 'not-found');
      },
      error: function() {
        alert('Failed to fetch email address');
        $spinner.replaceWith($target);
      }
    });
  });

  $(document).on("click", ".close-popover", function(e) {
    $(e.target).closest('.popover').popover("hide");
  });

  $(document).on('click', function (e) {
    if (
      !$(e.target).closest('.popover').length &&
      !$(e.target).closest('[data-toggle="popover"]').length
    ) {
      $('[data-toggle="popover"]').popover('hide');
    }
  });

  function isElementVisibleInWrapper(el: any, wrapper: any) {
    const elRect = el.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();

    const headerHeight = $('.gridjs-thead').outerHeight() || 0;

    return (
      elRect.top > wrapperRect.top + headerHeight &&
      elRect.bottom < wrapperRect.bottom &&
      elRect.left > wrapperRect.left &&
      elRect.right < wrapperRect.right
    );
  }

  function hidePopoverIfButtonHidden() {
    const wrapper = document.querySelector('.gridjs-wrapper');
    if (!wrapper) return;

    $('[data-toggle="popover"]').each(function () {
      const button = this;
      const popoverVisible = $(button).attr('aria-describedby');
      if (popoverVisible && !isElementVisibleInWrapper(button, wrapper)) {
        $(button).popover('hide');
      }
    });
  }

  const $wrapper = $('.gridjs-wrapper');
  $wrapper.on('scroll', hidePopoverIfButtonHidden);
  $(window).on('scroll', hidePopoverIfButtonHidden);
}

interface EmailAddressItem {
  email_address: string;
  best: boolean;
}

interface PersonalizedOutreachData {
  candidate_name: string;
  sequence: { id: string; name: string };
  email_addresses: EmailAddressItem[];
  gtm_campaign: boolean;
  subject: string;
  body: string;
  follow_ups: Array<{ position: number; wait_days: number; body: string }>;
}

export function initEmailModalButton(): void {
  $(document).off('click', '.email-button[data-bots-prospect-id]');
  $(document).on('click', '.email-button[data-bots-prospect-id]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $btn = $(this);
    const prospectId = $btn.data('prospect-id');
    const botsProspectId = $btn.data('bots-prospect-id');
    const botId = $btn.data('bot-id');
    if (!botsProspectId || !prospectId) return;

    // Hide any open popovers
    $('[data-toggle="popover"]').popover('hide');

    if ($btn.attr('data-personalized-outreach') === 'true' && botId) {
      showPersonalizedOutreachModal(String(botId), String(botsProspectId));
      return;
    }

    showEmailModalFor($btn);
  });

  // Handle modal close
  $(document).off('click', '.email-modal-close, .email-modal-overlay');
  $(document).on('click', '.email-modal-close, .email-modal-overlay', function(e) {
    if (e.target === this) {
      closeEmailModal();
    }
  });

  // Handle re-fetch (disabled for GTM campaigns)
  $(document).off('click', '.email-modal-refetch-btn');
  $(document).on('click', '.email-modal-refetch-btn', function() {
    const $btn = $(this);
    if ($btn.prop('disabled')) return;
    const $modal = $btn.closest('#email-modal');
    refetchEmailAddresses(
      String($btn.data('prospect-id') || ''),
      String($btn.data('bots-prospect-id') || $modal.data('bots-prospect-id'))
    );
  });
}

const MAX_VISIBLE_EMAILS = 5;

function emailButton(botsProspectId: string): JQuery {
  return $('.email-button-' + botsProspectId).first();
}

function refetchLabel(fetched: boolean): string {
  return `<i class="fas fa-sync"></i> <span class="font-weight-bold">${fetched ? 'Re-fetch email' : 'Fetch email'}</span>`;
}

function emailFetched(botsProspectId: string): boolean {
  return emailButton(botsProspectId).attr('data-email-fetched') === 'true';
}

function showEmailModalFor($btn: JQuery): void {
  let emails: EmailAddressItem[] = [];
  try {
    emails = JSON.parse($btn.attr('data-emails') || '[]');
  } catch {
    emails = [];
  }

  showEmailModal(
    String($btn.data('prospect-id')),
    String($btn.data('bots-prospect-id')),
    emails,
    $btn.attr('data-gtm-campaign') === 'true'
  );
}

function applyEmailListScroll(): void {
  const list = document.querySelector<HTMLElement>('#email-modal .email-modal-list');
  if (!list) return;

  const items = list.querySelectorAll<HTMLElement>('.email-modal-item');
  if (items.length > MAX_VISIBLE_EMAILS) {
    const first = items[0];
    const last = items[MAX_VISIBLE_EMAILS - 1];
    const maxHeight = last.offsetTop + last.offsetHeight - first.offsetTop;
    list.style.maxHeight = `${maxHeight}px`;
    list.style.overflowY = 'auto';
    list.style.paddingRight = '4px';
  } else {
    list.style.maxHeight = '';
    list.style.overflowY = '';
    list.style.paddingRight = '';
  }
}

function emailListHtml(emails: EmailAddressItem[]): string {
  if (!emails.length) {
    return '<div class="email-modal-empty">No personal email addresses found</div>';
  }

  return emails.map(email => `
    <div class="email-modal-item ${email.best ? 'best' : ''}">
      <span class="email-modal-address">${escapeHtml(email.email_address)}</span>
      ${email.best ? '<span class="email-modal-best-badge">Best</span>' : ''}
    </div>
  `).join('');
}

function showEmailModal(prospectId: string, botsProspectId: string, emails: EmailAddressItem[], isGtm: boolean): void {
  $('#email-modal-container').remove();

  const refetchDisabled = isGtm ? 'disabled title="Re-fetch is not available for GTM campaigns"' : '';

  const modalHtml = `
    <div id="email-modal-container" class="camp-refresh">
      <div class="email-modal-overlay"></div>
      <div id="email-modal" class="email-modal" data-bots-prospect-id="${botsProspectId}" data-prospect-id="${prospectId}">
        <div class="email-modal-header">
          <span class="email-modal-title">Personal Email Addresses</span>
          <button class="email-modal-close">&times;</button>
        </div>
        <div class="email-modal-body">
          <div class="email-modal-list">${emailListHtml(emails)}</div>
          <button class="btn btn-sm btn-green rounded-2 email-modal-refetch-btn mt-2 ${isGtm ? 'd-none' : ''}" ${refetchDisabled} data-bots-prospect-id="${botsProspectId}" data-prospect-id="${prospectId}">
            ${refetchLabel(emailFetched(botsProspectId))}
          </button>
        </div>
      </div>
    </div>
  `;

  $('body').append(modalHtml);
  applyEmailListScroll();
}

function closeEmailModal(): void {
  $('#email-modal .summernote').each(function() {
    if ($(this).next('.note-editor').length) $(this).summernote('destroy');
  });
  $('#email-modal-container').remove();
}

function csrf(): string {
  return (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content || '';
}

function escapeHtml(value: string): string {
  return $('<div>').text(value).html();
}

function fieldName(field: string): string {
  return `personalized_outreach[${field}]`;
}

function outreachEditor(label: string, detail: string, field: string, value: string, initial: boolean = false): string {
  return `<div class="email-outreach-field ${initial ? 'email-outreach-initial' : ''}">
    <div class="email-outreach-step"><span class="email-outreach-step-pill ${initial ? 'initial' : ''}">${escapeHtml(label)}</span><span>${escapeHtml(detail)}</span></div>
    <textarea class="summernote email-outreach-editor" name="${fieldName(field)}">${escapeHtml(value)}</textarea>
  </div>`;
}

function outreachHtml(data: PersonalizedOutreachData, botsProspectId: string): string {
  const refetch = data.gtm_campaign ? '' : `<button type="button" class="btn btn-sm btn-green rounded-2 email-modal-refetch-btn">
    ${refetchLabel(emailFetched(botsProspectId))}
  </button>`;
  const emails = emailListHtml(data.email_addresses);
  const followUps = data.follow_ups.map(followUp => outreachEditor(
    `Follow-up ${followUp.position}`,
    `waits ${followUp.wait_days} day${followUp.wait_days === 1 ? '' : 's'} if no reply`,
    `follow_up_${followUp.position}_body`,
    followUp.body
  )).join('');

  return `<div id="email-modal-container" class="camp-refresh">
    <div class="email-modal-overlay"></div>
    <div id="email-modal" class="email-modal email-outreach-modal">
      <div class="email-modal-header">
        <div><span class="email-modal-title">Personalize outreach</span><div class="email-outreach-context">To <strong>${escapeHtml(data.candidate_name)}</strong> · pre-filled from the <strong>${escapeHtml(data.sequence.name)}</strong> sequence</div></div>
        <button type="button" class="email-modal-close">&times;</button>
      </div>
      <div class="email-modal-body">
        <section class="email-outreach-addresses"><div class="email-outreach-section-title">Personal email addresses</div><div class="email-modal-list">${emails}</div>${refetch}</section>
        <form id="email-outreach-form" class="email-outreach-form">
          <input type="hidden" name="${fieldName('sequence_id')}" value="${escapeHtml(data.sequence.id)}">
          <div class="email-outreach-field email-outreach-subject"><label>Subject</label><input class="form-control" name="${fieldName('subject')}" value="${escapeHtml(data.subject)}"></div>
          ${outreachEditor('Initial email', 'sends immediately', 'body', data.body, true)}
          ${followUps}
          <div class="email-outreach-errors" role="alert"></div>
        </form>
      </div>
      <div class="email-outreach-footer"><div>Edits apply to this candidate only — the sequence template is unchanged.</div><div class="email-outreach-actions"><button type="button" class="btn btn-light email-modal-close">Cancel</button><button type="submit" form="email-outreach-form" class="btn btn-green"><i class="fas fa-check"></i> Save &amp; queue</button></div></div>
    </div>
  </div>`;
}

function initializeOutreachEditors(): void {
  $('#email-modal .summernote').summernote({
    dialogsInBody: true,
    codeviewFilter: true,
    codeviewIframeFilter: true,
    minHeight: 140,
    toolbar: [
      ['style', ['bold', 'italic']],
      ['insert', ['link']],
      ['misc', ['codeview']],
    ],
  });
}

function showPersonalizedOutreachModal(botId: string, botsProspectId: string): void {
  $.ajax({
    url: `/bots/${botId}/prospects/${botsProspectId}/personalized_outreach`,
    type: 'GET',
    headers: { Accept: 'application/json' },
    success: function(data: PersonalizedOutreachData) {
      $('#email-modal-container').remove();
      $('body').append(outreachHtml(data, botsProspectId));
      $('#email-modal').attr('data-bot-id', botId).attr('data-bots-prospect-id', botsProspectId);
      initializeOutreachEditors();
      applyEmailListScroll();
    },
    error: function() {
      const $btn = emailButton(botsProspectId);
      $btn.attr('data-personalized-outreach', 'false').attr('data-personalized-outreach-candidate', 'false');
      if (!$('#email-modal-container').length) showEmailModalFor($btn);
    }
  });
}

function refetchEmailAddresses(prospectId: string, botsProspectId: string): void {
  const $refetch = $('.email-modal-refetch-btn');
  $refetch.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> &nbsp; Fetching...');

  $.ajax({
    url: `/bots_prospects/${botsProspectId}/fetch_email_addresses`,
    type: 'POST',
    success: function(data: { status: string; email_addresses?: EmailAddressItem[] }) {
      const emails = data.email_addresses || [];
      $('#email-modal .email-modal-list').html(emailListHtml(emails));
      applyEmailListScroll();

      // Keep the underlying button in sync so re-opening shows the fresh list.
      const $btn = $('.email-button-' + botsProspectId);
      $btn.attr('data-emails', JSON.stringify(emails)).attr('data-email-fetched', 'true');
      if (emails.length) {
        $btn.removeClass('not-found').addClass('found');
      } else {
        $btn.removeClass('found').addClass('not-found');
      }

      const botId = $('#email-modal').data('bot-id') || $btn.data('bot-id');
      if (emails.length && $btn.attr('data-personalized-outreach-candidate') === 'true' && botId) {
        $btn.attr('data-personalized-outreach', 'true');
        showPersonalizedOutreachModal(String(botId), botsProspectId);
      }
    },
    error: function() {
      alert('Failed to fetch email address');
    },
    complete: function() {
      $refetch.prop('disabled', false).html(refetchLabel(emailFetched(botsProspectId)));
    }
  });
}

$(document).off('submit', '.email-outreach-form').on('submit', '.email-outreach-form', function(event) {
  event.preventDefault();
  const $form = $(this);
  const $modal = $('#email-modal');
  const botId = String($modal.data('bot-id'));
  const botsProspectId = String($modal.data('bots-prospect-id'));
  const payload: Record<string, string> = {};

  $form.find('.summernote').each(function() {
    const $editor = $(this);
    $editor.val($editor.summernote('code'));
  });
  $form.serializeArray().forEach(({name, value}) => { payload[name] = value; });
  const submit = $form.find('button[type="submit"]');
  submit.prop('disabled', true);
  $form.find('.email-outreach-errors').empty();

  $.ajax({
    url: `/bots/${botId}/prospects/${botsProspectId}/save_personalized_outreach`,
    type: 'POST',
    headers: { 'X-CSRF-Token': csrf(), Accept: 'application/json' },
    data: payload,
    success: function() { window.location.reload(); },
    error: function(xhr) {
      const errors = (xhr.responseJSON && xhr.responseJSON.errors) || ['Unable to save personalized outreach.'];
      $form.find('.email-outreach-errors').text(errors.join(' '));
      submit.prop('disabled', false);
    }
  });
});
